import { BrandEnvService } from './services/brand-env.service';
import { DelinquentService } from './services/delinquent.service';
import { BrtService } from './services/brt.service';
import { EncryptionService } from "./services/encryption.service";
import { convertParamsToString } from './utilities';

export var LiveChat = (function() {
  function LiveChat(accountId, websiteId, buttonIdMapping, creditOpsRedirectionExcluded) {
    this.accountId = accountId;
    this.websiteId = websiteId;
    this.buttonIdMapping = buttonIdMapping;
    this.creditOpsRedirectionExcluded = creditOpsRedirectionExcluded;
    this.encryptedData = '';
    this.lcLoaded = false;
    this.delinquentStatus = false;
    this.addCreditOpsHiddenButton();
    this.bcLoad();
  }

  LiveChat.prototype.bcLoad = function() {
    if (window.bcLoaded) return;
    window.bcLoaded = true;
    var vms = document.createElement('script');
    vms.type = 'text/javascript';
    vms.src = '//vmss.boldchat.com/aid/' + this.accountId + '/bc.vms4/vms.js';
    vms.async = true;
    document.querySelector('head').appendChild(vms);
  };

  LiveChat.prototype.generateButton = function(options) {
    if (!options) return;
    var bdidVal = 'bdidVal' in options ? options.bdidVal : null;
    var divIdVal = 'divIdVal' in options ? options.divIdVal : null;
    var secureParams =  this.encryptedData;
    var vn = 'vn' in options ? options.vn : null;

    window._bcvma = window._bcvma || [];
    _bcvma.push(['setAccountID', this.accountId]);
    _bcvma.push(['setParameter', 'WebsiteID', this.websiteId]);
    _bcvma.push(['setParameter', 'CustomUrl', '']);
    _bcvma.push(['setParameter', 'WindowParameters', 'vr=&ve=&vp=&vn=&lc=']);
    if (secureParams && secureParams!== '') {
      _bcvma.push([
          'setParameter',
          'SecureParameters',
          function(callback) {
              callback(secureParams);
          }
      ]);
    }
    _bcvma.push(['addStatic', { type: 'chat', bdid: bdidVal, id: divIdVal }]);
    window['_bcvma'].push(['pageViewed']);
    if (window.pageViewer && pageViewer.load) {
      pageViewer.load();
    }
  };

  LiveChat.prototype.getLcPlaceholderElements = function() {
    return document.querySelectorAll('[data-lc-btn-placeholder]');
  };

  LiveChat.prototype.getButtonIdByKey = function(key) {
    return this.buttonIdMapping[key];
  };

  LiveChat.prototype.getCreditOpsButtonId = function() {
    var language = BrandEnvService.getCurrentLang();
    var key;
    switch (language) {
      case 'en':
        key = 'credit-ops';
        break;
      case 'fr':
        key = 'credit-ops-fr';
        break;
      default:
        key = 'credit-ops';
    }
    return this.buttonIdMapping[key];
  };

  LiveChat.prototype.addCreditOpsHiddenButton = function () {
    var div = document.createElement('div');
    div.style.position = 'absolute';
    div.style.width = 0;
    div.style.height = 0;
    div.style.visibility = 'hidden';
    this.creditOpsElementId = Math.random();
    div.id = this.creditOpsElementId;
    document.querySelector('body').appendChild(div);
    this.generateButton({
        divIdVal: this.creditOpsElementId,
        bdidVal: this.getCreditOpsButtonId()
    });
  };

  LiveChat.prototype.routeButtonsToCreditOps = function() {
    var creditOpsElementId = this.creditOpsElementId;
    if (this.getLcPlaceholderElements().length < 1) {
      setTimeout(
        function() {
          this.routeButtonsToCreditOps();
        }.bind(this),
        500
      );
    } else {
      var interceptClick = function(elem) {
        elem.addEventListener(
          'click',
          function(event) {
            event.stopPropagation();
            document.getElementById(creditOpsElementId).childNodes[0].click();
          },
          true
        );
      };
      var lcPlaceholder = this.getLcPlaceholderElements();
      for (var i = 0; i < lcPlaceholder.length; i++) {
          if(this.creditOpsRedirectionExcluded.indexOf(lcPlaceholder[i].dataset.lcBtnPlaceholder) === -1) {
              interceptClick(lcPlaceholder[i]);
          }
      }
    }
  };

  LiveChat.prototype.attachIds = function() {
    var lcPlaceholder = this.getLcPlaceholderElements();
    if (lcPlaceholder.length >= 0) {
      for (var i = 0; i < lcPlaceholder.length; i++) {
        if (!lcPlaceholder[i].classList.contains('bcStatic')) {
          var options = {};
          options.divIdVal = Math.random();
          options.bdidVal = this.getButtonIdByKey(
            lcPlaceholder[i].getAttribute('data-lc-btn-placeholder')
          );
          lcPlaceholder[i].id = options.divIdVal;
          lcPlaceholder[i].dataset.buttonId = options.bdidVal;
          lcPlaceholder[i].innerHTML = '';
          this.generateButton(options);
        }
      }
    }
  };

  LiveChat.prototype.getEncryptedData = function (cb) {
      EncryptionService.getEncryptedData().then(function(response) {
          var encryptedData;
          if (response && response !== '') {
              encryptedData = {
                  CxA: decodeURIComponent(response.encryptedName || ''),
                  CxB: decodeURIComponent(response.encryptedCtn || ''),
                  CxC: decodeURIComponent(response.encryptedBan || '')
              };
              cb(null, encryptedData);
          } else {
              cb('error getting encrypted data: empty response');
          }
      }).catch(function() {
          cb('error getting encrypted data: catch block');
      });
  };

  LiveChat.prototype.initializeButtons = function(params) {
      var self = this;

      if (!params) params = {};
      var checkDelinquent =
          'checkDelinquent' in params ? params.checkDelinquent : false;
      var checkPermission =
          'checkPermission' in params ? params.checkPermission : false;
      var sendEncryptedData =
          'sendEncryptedData' in params ? params.sendEncryptedData : false;
      var accountNumber =
          'accountNumber' in params ? params.accountNumber : null;

      Promise.resolve()
          .then(function() {
              if (sendEncryptedData) {
                  BrandEnvService.setAccountNumber(accountNumber);
                  if (!accountNumber) return;
                  return processSendingEncryptedData(accountNumber);
              }
          })
          .then(function() {
              if (checkPermission) {
                  return processPermissionCheck();
              }
          })
          .then(function() {
              self.attachIds();
          })
          .then(function() {
              if (checkDelinquent) {
                  return processDelinquentCheck();
              }
          })
          .then(function () {
              self.lcLoaded = true;
          })
          .catch(function(err) {
              console.log('Error in promise chain of initializeButtons method',err);
          });

      function processPermissionCheck() {
          return BrtService.getPermission().then(function(permission) {
              if (permission) return true;
              else throw new Error('Permission not found');
          });
      }
      function processSendingEncryptedData() {
          return EncryptionService.getEncryptedData().then(function(response) {
              if (response && response !== '') {
                  self.encryptedData = convertParamsToString({
                      customField_CxA: response.encryptedName,
                      customField_CxB: response.encryptedCtn,
                      customField_CxC: response.encryptedBan
                  });
              }
          });
      }

      function processDelinquentCheck() {
          return DelinquentService.getStatus()
              .then(function(delinquentStatus) {
                  if (delinquentStatus) {
                      self.delinquentStatus = true;
                      self.routeButtonsToCreditOps();
                  }
              }
          ).catch(function (err) {
              return null;
          });
      }

  };

  return LiveChat;
})();
